export const SummaryMetricsStatsSelectors = [
  'totalSales',
  'newCustomerSales',
  'netSales',
  'rcRevenue',
  'totalPaymentGatewayCosts',
  'totalProductCostsOrders',
  'totalCostsRefunds',
  'totalProductCosts',
  'totalHandlingFees',
  'totalCustomSpends',
  'totalNewGrossSales',
  'totalCustomAdSpends',
  'totalCustomNonAdSpends',
  'totalInventoryItems',
  'totalInventoryItemsMissing',
  'totalInventoryCost',
  'totalInventoryValue',
  'shopifyAov',
  'shopifyAovIncludeZero',
  'shopifyCpa',
  'averageGaRevenuePerTransaction',
  'fb_ads_spend',
  'ga_adCost',
  'googleAllCpa',
  'googleBounceRate',
  'googleConversionValue',
  'totalSnapchatSpend',
  'totalSnapchatRoas',
  'snapchatImpressions',
  'snapchat_swipes',
  'snapchatCpm',
  'snapchatCpa',
  'totalSnapchatConversionPurchasesValue',
  'totalSnapchatConversionPurchases',
  'averageGaTransactionsPerSession',
  'totalGoogleAnalyticsSessions',
  'totalOrders',
  'totalOrdersWithAmount',
  'totalNetProfit',
  'cashTurnover',
  'totalNetMargin',
  'totalCpa',
  'totalRevenuePerSession',
  'totalRefunds',
  'fb_ads_purchase_roas',
  'ga_ROAS',
  'totalGoogleAdsCtr',
  'totalGoogleAdsCpm',
  'googleCpc',
  'totalGoogleAdsClicks',
  'totalGoogleAdsImpressions',
  'ga_transactions_adGroup',
  'ga_all_transactions_adGroup',
  'ga_all_transactionsRevenue_adGroup',
  'ga_all_transactions_adGroup',
  'totalAllRoas',
  'googleCpa',
  'averageFacebookCpc',
  'averageFacebookCpm',
  'facebookCtr',
  'facebookCostPerOutboundClick',
  'facebookConversionValue',
  'facebookRevenuePerClick',
  'facebookCpa',
  'facebookViewThrough',
  'facebookViewThroughRoas',
  'facebookViewThroughCpa',
  'facebookPurchases',
  'facebookMetaPurchases',
  'facebookWebPurchases',
  'facebookWebConversionValue',
  'facebookMetaConversionValue',
  'newCustomersCpa',
  'totalKlaviyoPlacedOrderSalesPercent',
  'totalKlaviyoPlacedOrderSalesPercentFlows',
  'totalKlaviyoPlacedOrderSalesPercentCampaigns',
  'klaviyoEmailOpenRate',
  'totalKlaviyoUnsubscribed',
  'totalKlaviyoPlacedOrderTotalPriceFlows',
  'totalKlaviyoPlacedOrderSalesPercentFlows',
  'totalKlaviyoPlacedOrderTotalPriceCampaigns',
  'totalKlaviyoPlacedOrderSalesPercentCampaigns',
  'totalKlaviyoSubscribedToList',
  'totalKlaviyoClickedEmail',
  'totalKlaviyoReceivedEmail',
  'totalKlaviyoClickedSms',
  'klaviyoCVR',
  'klaviyoRevenuePerEmail',
  'totalKlaviyoNetNewSubscribers',
  'klaviyoPlacedOrderSales',
  'attentivePlacedOrderSales',
  'totalAttentivePlacedOrder',
  'tiktok_spend',
  'tiktok_complete_payment_roas',
  'tiktokImpressions',
  'averageTiktokCpm',
  'averageTiktokCpc',
  'tiktokCtr',
  'tiktokCpa',
  'tiktokConversionValue',
  'tiktokPurchases',
  'twitterCpm',
  'twitterCpa',
  'twitterConversionValue',
  'twitterPurchases',
  'twitterImpressions',
  'twitterEngagements',
  'twitterRoas',
  'twitter_complete_payment_roas',
  'twitter_spend',
  'twitterFollows',
  'twitterClicks',
  'uniqueCustomerLifetimeValue',
  'customerFrequency',
  'ltvCpa',
  'mer',
  'totalReturns',
  'totalOrders',
  'totalTaxes',
  'totalRefundTaxes',
  'totalNetTaxes',
  'newCustomersPercent',
  'oldCustomersPercent',
  'newCustomersOrders',
  'getUniqueCustomerCount',
  'totalShippingCosts',
  'totalDiscounts',
  'totalGoogleAnalyticsUsers',
  'totalGorgiasTicketsCreated',
  'totalGorgiasTicketsReplied',
  'averageGorgiasResponseTime',
  'averageGorgiasResolutionTime',
  'totalVariantsSold',
  'blendedAds',
  'totalRoas',
  'newCustomersRoas',
  'blendedAttributedRoas',
  'poas',
  'pinterestSpend',
  'pinterestRoas',
  'pinterestCpc',
  'pinterestCpm',
  'pinterestConversionValue',
  'pinterestPurchases',
  'pinterestImpressions',
  'pinterestCtr',
  'blendedSales',

  // dynamic
  'order_tags',
  'sources',
  'customMetrics',
  'willyMetric',
  'customMetricsAttribution',
  'externalApps',

  // benchmarks
  'totalBenchmarksCPM',
  'totalBenchmarksCPC',
  'totalBenchmarksCTR',
  'totalBenchmarksNCROAS',
  'totalBenchmarksNCPA',
  'totalBenchmarksBlendedROAS',
  'totalBenchmarksTotalSpendAvg',
  'totalBenchmarksNewCustomersAvg',
  'totalBenchmarksSize',
  'totalBenchmarksOrdersAvg',
  'totalBenchmarksNewCustomersTotalPriceAvg',
  'totalBenchmarksBlendedSpendAvg',
  'totalBenchmarksFBAdsSpendAvg',
  'totalBenchmarksFBAdsImpressionsAvg',
  'totalBenchmarksFBAdsClicksAvg',
  'benchmarksFacebookRoas',
  'benchmarksGoogleRoas',
  'totalBenchmarksCPCGoogle',
  'totalBenchmarksCPMGoogle',
  'totalBenchmarksCTRGoogle',
  'totalBenchmarksGoogleAdsSpendAvg',
  'totalBenchmarksCTRTiktok',
  'totalBenchmarksCPCTiktok',
  'benchmarksTiktokRoas',
  'totalBenchmarksTiktokAdsSpendAvg',
  'totalBenchmarksBlendedCTR',
  'totalBenchmarksBlendedCpc',

  // attentive
  'totalAttentiveNewSubscribed',
  'totalAttentiveNetNewsubscribers',
  'totalAttentiveUnsubscribed',
  'totalAttentivePlacedOrderSalesPercent',
  'totalAttentivePlacedOrderTotalPriceFlows',
  'totalAttentivePlacedOrderSalesPercentFlows',
  'totalAttentivePlacedOrderTotalPriceCampaigns',
  'totalAttentivePlacedOrderSalesPercentCampaigns',

  // enquirelabs
  'totalFacebookEnq',
  'totalGoogleEnq',
  'totalSnapchatEnq',
  'totalTiktokEnq',
  'totalPinterestEnq',
  'totalInstagramEnq',
  'responsesPrecent',

  // kno
  'totalFacebookKno',
  'totalGoogleKno',
  'totalSnapchatKno',
  'totalTiktokKno',
  'totalPinterestKno',
  'totalInstagramKno',
  'responsesPrecentKno',

  // recharge
  'rechargeNewSub',
  'rechargeTotalNewSubscriptions',
  'rechargeCanceledSub',
  'rechargeExpiredSub',
  'rechargeTotalActiveSubsribers',
  'rechargeTotalNetSales',
  'rechargeItemsCount',
  'rechargeTransactionCount',
  'rechargeChurnRate',
  'rechargeMRR',
  'rechargeTotalActiveCustomers',
  'rechargeTotalChurnedCustomers',

  // social
  'facebookLikes',
  'facebookComments',
  'facebookShares',
  'facebookPosts',
  'facebookFollowers',
  'facebookSocialImpressions',
  'facebookSocialAvg',
  'facebookReach',
  'facebookProfileView',
  'facebookWebsiteClicks',
  'instagramLikes',
  'instagramComments',
  'instagramShares',
  'instagramPosts',
  'instagramFollowers',
  'instagramImpressions',
  'instagramAvg',
  'instagramAvgImpressionsFollowers',
  'instagramReach',
  'instagramProfileView',
  'instagramWebsiteClicks',

  // influencers
  'influencerConversionValue',
  'influencerPurchases',
  'influencerSpend',
  'influencerRoas',
  'influencerNcPurchases',
  'influencerNcConversionValue',

  // amazon-sales
  'totalAmazonSales',
  'totalAmazonProductItemPrice',
  'totalAmazonSalesTaxes',
  'totalAmazonOrders',
  'totalAmazonItems',
  'totalAmazonFees',
  'totalAmazonSalesAFN',
  'totalAmazonProductItemPriceAFN',
  'totalAmazonSalesTaxesAFN',
  'totalAmazonOrdersAFN',
  'totalAmazonItemsAFN',
  'totalAmazonFeesAFN',
  'totalAmazonSalesMFN',
  'totalAmazonProductItemPriceMFN',
  'totalAmazonSalesTaxesMFN',
  'totalAmazonOrdersMFN',
  'totalAmazonItemsMFN',
  'totalAmazonFeesMFN',

  'totalCanceledAmazonSales',
  'totalCanceledAmazonProductItemPrice',
  'totalCanceledAmazonSalesTaxes',
  'totalCanceledAmazonOrders',
  'totalCanceledAmazonItems',
  'totalCanceledAmazonFees',
  'totalCanceledAmazonSalesAFN',
  'totalCanceledAmazonProductItemPriceAFN',
  'totalCanceledAmazonSalesTaxesAFN',
  'totalCanceledAmazonOrdersAFN',
  'totalCanceledAmazonItemsAFN',
  'totalCanceledAmazonFeesAFN',
  'totalCanceledAmazonSalesMFN',
  'totalCanceledAmazonProductItemPriceMFN',
  'totalCanceledAmazonSalesTaxesMFN',
  'totalCanceledAmazonOrdersMFN',
  'totalCanceledAmazonItemsMFN',
  'totalCanceledAmazonFeesMFN',

  // amazon-ads
  'amazonAds',
  'amazonROAS',
  'amazonCPC',
  'amazonClicks',
  'amazonPurchases',
  'amazonTACos',
  'amazonAdsConversionValue',

  // amazon-ads
  'amazonNetSales',
  'amazonNetProfit',
  // 'amazonROAS',
  'amazonMER',
  'amazonAOV',
  'amazonCPA',
  'amazonExpenses',
  // pixel
  'pixelUniqueVisitors',
  'pixelVisitors',
  'pixelUniqueAtc',
  'pixelUniqueSessionsAtc',
  'pixelPurchases',
  'pixelConversionRate',
  'pixelAvgPagesPerSession',
  'pixelAvgSessionDuration',
  'pixelBounceRate',
  'pixelNewVisitors',
  'pixelPercentNewVisitors',
  'pixelPercentAtc',
  'pixelCostPerAtc',
  'pixelCostPerSession',

  // bing
  'bingAdSpend',
  'bingConversions',
  'bingConversionValue',
  'bingClicks',
  'bingImpressions',
  'bingRoas',
  'bingCtr',
  'bingCpa',
  'bingCpm',

  //recharge
  'rechargeSubscription1stOrderSales',
  'rechargeSubscriptionRecurringOrder',
  'rechargeTotalSubscriptionSales',
  'rechargeSubscriptionSalesPercentage',
  'rechargeTotalNewSubscriptions',
  'rechargeTotalCancelledSubscriptions',
  'rechargeTotalChurnedSubscribers',
  'rechargeTotalActiveSubscriptions',
  'rechargeTotalActiveSubscribers',
  'rechargeAverageActiveDays',
  'rechargeAverageSubscriptionsPerCustomer',
  'rechargeReactivatedSubscribers',

  //stripe

  'stripeSubscriptionUpgradeCount',
  'stripeSubscriptionUpgradeAmount',
  'stripeSubscriptionDowngradeCount',
  'stripeSubscriptionDowngradeAmount',
  'stripeSubscriptionDeletedCount',
  'stripeSubscriptionDeletedAmount',

  //MNTN
  'mountainSpend',
  'mountainRoas',
  'mountainImpressions',
  'mountainConversions',
  'mountainConversionRate',
  'mountainAverageOrderValue',
  'mountainCostPerAcquisition',
  'mountainCostPerVisit',
  'mountainConversionValue',

  //criteo
  'criteoSpend',
  'criteoRoas',
  'criteoDisplays',
  'criteoConversions',
  'criteoConversionRate',
  'criteoVisits',
  'criteoClicks',
  'criteoAverageOrderValue',
  'criteoCostPerAcquisition',
  'criteoCostPerVisit',
  'criteoConversionValue',

  //pacing
  'pacing',

  //forwardView
  'forwardViewTotalRevenue',
  'forwardViewProductOrdersCount',
  'forwardViewNcCustomerCntAttribution',

  // shipstation
  'shipstationCost',
  'shipstationShipments',
  'shipstationOrders',
  'shipstationOrdersShipped',
  'shipstationOrdersUnshipped',
  'shipstationAvgCostPerShipment',
  'shipstationEstimation',

  //smsbump
  'smsbumpRevenue',
  'smsbumpCampaignRevenue',
  'smsbumpFlowRevenue',
  'smsbumpSpend',
  'smsbumpSent',
  'smsbumpUnsubscribed',
  'smsbumpConversions',
  'smsbumpAov',
  'smsbumpCtr',
  'smsbumpRoas',
  'smsbumpRoi',
  'smsbumpDelivered',
  'smsbumpClicks',

  //shipbob
  'shipbobOrders',
  'shipbobOrdersFulfilled',
  'shipbobPercentOfOrdersFulfilledOnTime',
  'shipbobFulfillmentCost',
  'shipbobAvgFulfillmentCost',
  'shipbobEstimation',

  //postscript
  'postscriptRevenue',
  'postscriptSent',
  'postscriptSubscribed',
  'postscriptUnsubscribed',
  'postscriptConversions',
  'postscriptDelivered',
  'postscriptAov',
  'postscriptCtr',
  'postscriptClicks',
] as const;
